const { initCreateStore } = require('./redux/store');
const store = initCreateStore();
const nextRedux = store.nextRedux;

module.exports = store;
module.exports.nextRedux = nextRedux;

export {};
